const DEFAULT_PRIMARY = '#2C3A59';
const DEFAULT_WARNING = '#f9b002';
const DEFAULT_MENU_TEXT = '#67748E';

function normalizeHex(color, fallback) {
  if (!color || typeof color !== 'string') {
    return fallback;
  }
  const value = color.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
    return value.toUpperCase();
  }
  return fallback;
}

function hexToRgb(hex) {
  const normalized = normalizeHex(hex, DEFAULT_PRIMARY).replace('#', '');
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
}

function rgbToHex(r, g, b) {
  const toHex = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}

function darkenHex(hex, percent) {
  const { r, g, b } = hexToRgb(hex);
  const factor = 1 - percent / 100;
  return rgbToHex(r * factor, g * factor, b * factor);
}

function mixHex(hexA, hexB, weightB = 0.5) {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  const w = Math.max(0, Math.min(1, weightB));
  return rgbToHex(
    a.r * (1 - w) + b.r * w,
    a.g * (1 - w) + b.g * w,
    a.b * (1 - w) + b.b * w,
  );
}

export function buildThemeBgGradient(primaryColor, warningColor) {
  const primary = normalizeHex(primaryColor, DEFAULT_PRIMARY);
  const warning = normalizeHex(warningColor, DEFAULT_WARNING);
  const primaryDark = darkenHex(primary, 28);
  const bgEnd = mixHex(primaryDark, warning, 0.35);
  return `linear-gradient(310deg, ${primary} 0%, ${primaryDark} 55%, ${bgEnd} 100%)`;
}

export function applyThemeColors(settings) {
  const root = document.documentElement;
  const primary = normalizeHex(settings?.primary_color, DEFAULT_PRIMARY);
  const warning = normalizeHex(settings?.warning_color, DEFAULT_WARNING);
  const menuText = normalizeHex(settings?.menu_text_color, DEFAULT_MENU_TEXT);
  const primaryDark = darkenHex(primary, 28);
  const warningDark = darkenHex(warning, 18);

  root.style.setProperty('--theme-primary', primary);
  root.style.setProperty('--theme-primary-dark', primaryDark);
  root.style.setProperty('--theme-warning', warning);
  root.style.setProperty('--theme-warning-dark', warningDark);
  root.style.setProperty('--theme-menu-text', menuText);
  root.style.setProperty('--theme-bg-gradient', buildThemeBgGradient(primary, warning));
  root.style.setProperty(
    '--theme-warning-gradient',
    `linear-gradient(310deg, ${warning} 0%, ${warningDark} 100%)`,
  );
}

export { DEFAULT_PRIMARY, DEFAULT_WARNING, DEFAULT_MENU_TEXT, normalizeHex };
